"use strict";
function toCallback(promise, cb) {
    promise.then(function (result) { return cb(null, result); }, function (err) { return cb(err, null); }).then(null, function (err) {
        // Don't swallow thrown errors
        setTimeout(function () {
            throw err;
        }, 0);
    });
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = toCallback;
//# sourceMappingURL=to.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/node_modules/promise-cb/to.js
// module id = 979
// module chunks = 81